module.exports = __webpack_public_path__ + "img/impact-zones-key.a5e5b855.jpg";